var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlBody6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 618,
    height: 704,
    viewBox: "0 0 618 704",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Body / 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skin color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1757 519.159L85.4425 475.24L113.477 333.318L42.1171 313.818C37.0312 392.202 38.0807 485.045 38.1162 488.044C30.8041 501.041 23.9051 525.218 20.5097 539.573C19.0757 545.643 20.7837 566.835 24.2117 578.459C26.1537 585.043 30.4417 591.147 30.4417 591.147C30.4417 591.147 35.5917 603.247 37.5997 604.303C43.2717 607.285 45.7757 601.463 45.7757 601.463C45.7757 601.463 49.5997 618.935 53.4957 617.225C55.8957 616.171 59.4237 612.905 59.5117 608.557C60.0677 580.873 65.4897 551.953 75.0037 546.961C81.1122 543.755 83.3226 554.638 85.3923 564.828C86.5462 570.509 87.6563 575.974 89.3737 578.663C94.0257 585.947 112.34 591.141 107.718 578.407C101.384 560.96 101.227 553.63 100.992 542.7C100.981 542.181 100.97 541.655 100.958 541.119C100.69 529.281 99.1757 519.159 99.1757 519.159ZM518.259 521.837C516.544 518.465 505.54 505.145 495.612 493.409L450.997 357.838C433.831 368.253 412.45 381.255 392.909 393.138L392.317 393.498L449.39 496.482C444.712 525.946 465.247 567.607 465.247 567.607C465.247 567.607 454.441 561.017 452.291 566.781C451.335 569.347 449.165 589.843 489.645 591.223C493.945 591.369 504.283 582.627 504.283 582.627C504.283 582.627 496.743 597.021 508.287 599.849C508.287 599.849 526.889 571.977 527.173 565.775C527.459 559.573 521.487 528.179 518.259 521.837Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    opacity: 0.146066,
    d: "M473.513 511.358C473.513 511.358 479.193 532.816 498.687 539.502C505.505 541.84 503.803 569.44 520.509 566.138",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sweater color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sweater",
    d: "M450.998 357.839C433.658 368.359 412.018 381.519 392.318 393.499L374.058 359.999L372.138 342.999L198.498 340.439C198.498 340.439 199.998 324.259 196.318 300.879C191.478 270.299 166.178 235.339 166.178 235.339L121.238 294.099L113.478 333.319L42.1177 313.819C45.1377 289.919 47.7377 266.959 54.6177 247.479C81.1577 172.139 128.498 87.0792 166.318 63.2392C205.238 38.7192 240.318 45.1792 272.878 46.8992C329.158 49.8392 356.978 49.2592 382.138 72.3592C434.618 120.519 433.038 302.399 433.038 302.399L450.998 357.839Z",
    fill: "#72A065"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 13",
    opacity: 0.203265,
    d: "M370.544 342.533C376.96 261.047 421.37 243.817 389.37 152.433",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neck color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Neck",
    d: "M234.372 44.5696L238.036 18L325.414 30.046L322.878 48.4386C339.342 51.0403 348.335 54.083 348.335 54.083L331.679 176.689L218.059 44.843C218.059 44.843 223.16 44.6497 234.372 44.5696Z",
    fill: "#2437A8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 17",
    opacity: 0.203265,
    d: "M203.503 180.356L166.169 235.33",
    stroke: "black",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlBody6);
export default __webpack_public_path__ + "static/media/Girl-Body-6.51a4b59b.svg";
export { ForwardRef as ReactComponent };